import React from 'react';
import { createRoot } from 'react-dom/client';
import CaterbaseApp from './caterbase.jsx';

createRoot(document.getElementById('root')).render(<CaterbaseApp />);
